import script from "./UploadQueue.vue?vue&type=script&lang=ts&setup=true"
export * from "./UploadQueue.vue?vue&type=script&lang=ts&setup=true"

import "./UploadQueue.vue?vue&type=style&index=0&id=5bf5d0c6&scoped=true&lang=scss"

import exportComponent from "/var/build/production/buyers-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5bf5d0c6"]])

export default __exports__